// Historial de llamadas tal como lo entrega 3CX (Data Connector -> PostgreSQL -> servicio cdr/api).
import { request } from './http';

export type FuenteCdr = 'real' | 'demo';

export type EstadoFuente = {
  id: FuenteCdr;
  nombre: string;
  disponible: boolean;
  base?: string | null;
  motivo?: 'sin-datos' | 'sin-base' | 'error';
  llamadas?: number;
  desde?: string | null;
  hasta?: string | null;
};

export type DireccionCdr = 'ENTRANTE' | 'SALIENTE' | 'INTERNA';
// CONTESTADA: la atendio una persona (o el numero externo, si es saliente). AUTOMATICA: solo un IVR o flujo.
// FALLIDA: la central no pudo sacarla (sin troncal, limite de licencia...). RECHAZADA: ocupado o rechazo.
export type EstadoCdr = 'CONTESTADA' | 'PERDIDA' | 'BUZON' | 'AUTOMATICA' | 'NO_CONTESTADA' | 'RECHAZADA' | 'FALLIDA';

export type Tramo = {
  inicio: string;
  desde: string;
  hacia: string;
  tipoHacia: string;
  como: string;
  timbradoSeg: number;
  habladoSeg: number;
  contestado: boolean;
  fin: string;
};

export type LlamadaCdr = {
  id: string;
  inicio: string;
  fin: string;
  direccion: DireccionCdr;
  origen: 'NORMAL' | 'CLIC_PARA_LLAMAR' | 'DEVOLUCION_COLA';
  estado: EstadoCdr;
  detalle: string;
  numero: string;
  nombreExterno: string;
  did: string;
  troncal: { numero: string; nombre: string; tipo: string } | null;
  agente: { extension: string; nombre: string } | null;
  cola: { extension: string; nombre: string } | null;
  esperaSeg: number;
  habladoSeg: number;
  facturableSeg: number;
  transferida: boolean;
  grabaciones: number;
  tramos: Tramo[];
};

export const estadoCdr = () => request<{ fuentes: EstadoFuente[] }>('/cdr/estado').then((r) => r.fuentes);

export const llamadasCdr = (fuente: FuenteCdr, desde: Date, hasta: Date) =>
  request<{ llamadas: LlamadaCdr[] }>('/cdr/llamadas', { query: { fuente, desde: desde.toISOString(), hasta: hasta.toISOString() } }).then((r) => r.llamadas);

// Lo que se escribe en 3CX: Admin → Integraciones → Data Connectors → PostgreSQL. Solo administradores.
export type ConexionCdr = { servidor: string; puerto: number; base: string; usuario: string; clave: string; ssl: boolean; ipsPermitidas: string[] };

export const conexionCdr = () => request<ConexionCdr>('/cdr/conexion');

// D80: resumen, transcripcion y sentimiento que hace la IA de 3CX de una llamada (si esta activa en la central y el
// Data Connector envia "Recordings Data").
export type Analisis3cx = { resumen: string | null; transcripcion: string | null; sentimiento: number | null; grabacion: string | null };
export const analisisLlamada = (inicio: string, numero: string, agente: string) =>
  request<{ analisis: Analisis3cx | null }>(`/cdr/analisis?${new URLSearchParams({ inicio, numero, agente })}`).then((r) => r.analisis);
